import * as React from 'react';
import { Heading, Text } from '@grandvisionhq/elements';

const ConfiguratorStepTitleAndDescription = ({ title , description , descriptionSuffix , textAlignment ='center' ,  })=>{
    const hasDescriptionOrSuffix = description || descriptionSuffix;
    const hasDescriptionAndSuffix = description && descriptionSuffix;
    return /*#__PURE__*/ React.createElement("div", {
        className: "configurator-step-headings"
    }, /*#__PURE__*/ React.createElement(Heading, {
        component: "h2",
        variant: "medium",
        align: textAlignment,
        className: "configurator-step-headings__title"
    }, title), hasDescriptionOrSuffix && /*#__PURE__*/ React.createElement(Text, {
        className: "configurator-step-headings__description",
        variant: "body",
        align: textAlignment
    }, description, hasDescriptionAndSuffix && ' ', descriptionSuffix));
};

export { ConfiguratorStepTitleAndDescription as default };
//# sourceMappingURL=ConfiguratorStepTitleAndDescription.js.map
